const baseURL = process.env.REACT_APP_BASE_URL + 'crm/';
export async function insert_new_opportunity (token, name, channel_id,description, protectedUntil, closingDate, country, type, stage,oppStatus,  opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('name', name);
    data.append('channel_id', channel_id);
    data.append('description', description);
    data.append('oppStatus', oppStatus);

    data.append('protectedUntil',(protectedUntil===""||protectedUntil==="0000-00-00" ? '' : (new Date(protectedUntil)).toISOString().split('T')[0]));
    data.append('closingDate',(closingDate===""||closingDate==="0000-00-00"  ? '' : (new Date(closingDate)).toISOString().split('T')[0]));
    
    data.append('country', country);
    data.append('type', type);
    data.append('stage', stage);
    if (opportunity_id === "new"){
        data.append('opportunity_id', 0);
    }else if (Number.isInteger(parseInt( opportunity_id))){
        data.append('opportunity_id', opportunity_id);
    }

   
    
    let result = await loadJson (data, 'set/update_opportunity');
    return result;
}

export async function insert_new_channel (token,name, description,  country, channel_id, source_strategy, selectedTier) {
    const data = new FormData();
    data.append('token', token);
    data.append('name', name);
    data.append('description', description);
    data.append('country', country);
    data.append('source_strategy', source_strategy);
    data.append('selectedTier', selectedTier);

    if (channel_id === "new"){
        data.append('channel_id', 0);
    }else if (Number.isInteger(parseInt( channel_id))){
        data.append('channel_id', channel_id);
    }

    let result = await loadJson (data, 'set/update_channel');
    return result;
}

export async function add_workshop(token, name, event_goals, event_link, event_date, templateFile) {
    const data = new FormData();
    data.append('token', token);
    data.append('name', name);
    data.append('event_goals', event_goals);
    data.append('event_link', event_link);
    data.append('event_date', event_date);
    if (templateFile) {
        data.append('template_file', templateFile);
    }
    let result = await loadJson(data, 'set/add_workshop');
    return result;
}

export async function list_workshops(token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson(data, 'get/list_workshops');
    return result;
}

export async function update_workshop(token, workshop_id, name, event_goals, event_link, event_date, templateFile) {
    const data = new FormData();
    data.append('token', token);
    data.append('workshop_id', workshop_id);
    data.append('name', name);
    data.append('event_goals', event_goals);
    data.append('event_link', event_link);
    data.append('event_date', event_date);
    if (templateFile) {
        data.append('template_file', templateFile);
    }
    let result = await loadJson(data, 'set/update_workshop');
    return result;
}

export async function delete_workshop(token, workshop_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('workshop_id', workshop_id);
    let result = await loadJson(data, 'set/delete_workshop');
    return result;
}



export async function certify_channel (token,  channel_id, file) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    data.append('file', file);

    let result = await loadJson (data, 'set/certify_channel');
    return result;
}



export async function add_user_permission (token, opportunity_id, email_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    data.append('email_id', email_id);
    let result = await loadJson (data, 'set/add_user_permission2');
    return result;
}

export async function add_opportunity_project (token, opportunity_id, project_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    data.append('project_id', project_id);
    let result = await loadJson (data, 'set/add_opportunity_project');
    return result;
}

export async function load_jobs_positions (token) {
    //optiene las posiciones de trabajo del maestro 
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'get/load_jobs_positions');
    return result;
}


export async function load_contact_profile (token, email) {
    const data = new FormData();
    data.append('token', token);
    data.append('email', email);
    let result = await loadJson (data, 'get/load_contact_profile');
    return result;
}

export async function save_contact_info (token, usr_data, channel_id = '') {
    const data = new FormData();
    data.append('token', token);
    data.append('id', usr_data.id);
    data.append('name', usr_data.name);
    data.append('position_id', usr_data.position_id);
    data.append('country', usr_data.country);
    data.append('phone_country_code', usr_data.phone_country_code);
    data.append('phone', usr_data.phone);
    data.append('language', usr_data.language);
    data.append('countryCode', usr_data.countryCode);
    if (channel_id) {
        data.append('channel_id', channel_id);
    }

   
    let result = await loadJson (data, 'set/save_contact_info');
    return result;
}

export async function update_channel_user_permission (token, channel_id, permission_id, permission) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    data.append('permission_id', permission_id);
    data.append('permission', permission);
    let result = await loadJson(data, 'set/update_channel_user_permission');
    return result;
}

export async function add_user_permission_channel (token, channel_id, email_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    data.append('email_id', email_id);
    let result = await loadJson (data, 'set/add_user_permission_channel2');
    return result;
}


export async function create_contact (token,  email_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('email_id', email_id);
    let result = await loadJson (data, 'set/create_contact');
    return result;
}


export async function opportunity_status_change(token,opportunity_id, destinyStatus, description) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    data.append('destinyStatus', destinyStatus);
    data.append('description', description);

    let result = await loadJson (data, 'set/opportunity_status_change');
    return result;
}


export async function send_newLogEntry(token,opportunity_id, description, type = 2, isPrivate = false,  expiryDate = '') {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    data.append('description', description);
    data.append('type', type);
    data.append('isPrivate', isPrivate ? 1 : 0);
    if (expiryDate != '') {
        data.append('expiryDate', (new Date(expiryDate)).toISOString().split('T')[0]);
    } else {
        data.append('expiryDate', '');
    }
    let result = await loadJson (data, 'set/send_newLogEntry');
    return result;
}

export async function send_channel_newLogEntry(token,channel_id, description) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    data.append('description', description);

    let result = await loadJson (data, 'set/send_channel_newLogEntry');
    return result;
}

export async function add_card_to_opportunity (token, opportunity_id, trello_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    data.append('trello_id', trello_id);
    let result = await loadJson (data, 'set/add_card_to_opportunity');
    return result;
}
export async function add_card_to_channel (token, channel_id, trello_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    data.append('trello_id', trello_id);
    let result = await loadJson (data, 'set/add_card_to_channel');
    return result;
}

export async function remove_permission (token, permission_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('permission_id', permission_id);
    let result = await loadJson (data, 'set/remove_permission');
    return result;
}

export async function remove_linked_project (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    let result = await loadJson (data, 'set/remove_linked_project');
    return result;
}

export async function remove_permission_channel (token, permission_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('permission_id', permission_id);
    let result = await loadJson (data, 'set/remove_permission_channel');
    return result;
}
export async function remove_channel_permission (token, permission_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('permission_id', permission_id);
    let result = await loadJson (data, 'set/remove_channel_permission');
    return result;
}

export async function remove_card_link (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    let result = await loadJson (data, 'set/remove_card_link');
    return result;
}

export async function delete_opportunity (token, opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    let result = await loadJson (data, 'set/delete_opportunity');
    return result;
}

export async function load_opportunity (token,opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    let result = await loadJson (data, 'get/load_opportunity');
    return result;
}

export async function load_channel (token, channel_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    let result = await loadJson (data, 'get/load_channel2');
    return result;
}


export async function list_channels (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'get/list_channels');
    return result;
}

export async function load_channel_tomis (token,channel_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    let result = await loadJson (data, 'get/load_channel_tomis');
    return result;
}

export async function link_tomi_to_channel (token, channel_id, tomi_serial) {
    const data = new FormData();
    data.append('token', token);
    data.append('tomi_serial', tomi_serial);
    data.append('channel_id', channel_id);
    let result = await loadJson (data, 'set/link_tomi_to_channel');
    return result;
}


export async function remove_tomi_link (token, link_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('link_id', link_id);
    let result = await loadJson (data, 'set/remove_tomi_link');
    return result;
}


export async function list_opportunities (token, channel_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    let result = await loadJson (data, 'get/list_opportunities');
    return result;
}

export async function list_QRs (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'get/list_QRs');
    return result;
}


export async function newLink (token, title, longURL, shortURL, selectedFile) {
    const data = new FormData();
    data.append('token', token);
    data.append('title', title);
    data.append('longURL', longURL);
    data.append('shortURL', shortURL);
    data.append('file', selectedFile);
    let result = await loadJson (data, 'set/newLink');
    return result;
}

export async function move_links_to_folder(token, ids, folder) {
    const data = new FormData();
    data.append('token', token);
    data.append('ids', Array.isArray(ids) ? ids.join(',') : ids);
    data.append('folder', folder);
    let result = await loadJson(data, 'set/move_link_folder');
    return result;
}

export async function list_card_opportunities (token, card_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('card_id', card_id);
    let result = await loadJson (data, 'get/list_card_opportunities');
    return result;
}


export async function save_new_stgy_split (token, id, value) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('value', value);
    let result = await loadJson (data, 'get/save_new_stgy_split');
    return result;
}

export async function load_products (token) {
    const data = new FormData();
    data.append('token', token);
    let result = await loadJson (data, 'get/load_products');
    return result;
}

export async function add_product_to_opp (token, opportunity_id, product_id, units, pvp = 0) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    data.append('product_id', product_id);
    data.append('units', units);
    data.append('pvp', pvp);
    let result = await loadJson (data, 'set/add_product_to_opp');
    return result;
}

export async function remove_product_to_opp (token, id) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    let result = await loadJson (data, 'set/remove_product_to_opp');
    return result;
}

export async function update_opp_product_pvp (token, id, pvp) {
    const data = new FormData();
    data.append('token', token);
    data.append('id', id);
    data.append('pvp', pvp);
    let result = await loadJson (data, 'set/update_opp_product_pvp');
    return result;
}


export async function load_opportunity_log (token, opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    let result = await loadJson (data, 'get/load_opportunity_log');
    return result;
}


export async function check_task (token, taskId, newStatus) {
    const data = new FormData();
    data.append('token', token);
    data.append('taskId', taskId);
    data.append('newStatus', newStatus);
    let result = await loadJson (data, 'set/check_task');
    return result;
}

export async function load_channel_log (token, channel_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('channel_id', channel_id);
    let result = await loadJson (data, 'get/load_channel_log');
    return result;
}


export async function load_opportunity_products (token, opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    let result = await loadJson (data, 'get/load_opp_products');
    return result;
}

export async function load_opportunity_cards (token,opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    let result = await loadJson (data, 'get/load_opportunity_cards');
    return result;
}


export async function load_opportunity_projects (token,opportunity_id) {
    const data = new FormData();
    data.append('token', token);
    data.append('opportunity_id', opportunity_id);
    let result = await loadJson (data, 'get/load_opportunity_projects');
    return result;
}

async function loadJson (data, url) {

    try {

        const response = await fetch(baseURL + url + ".php", {
            method: 'POST',
            body: data
        });
        const resp = await response.text();

        if(resp !== "INVALID"){
            try{
                const jsonResult = JSON.parse(resp);
                return jsonResult;
            }catch(err){
                return resp;
            }
            
        }else{
            return "INVALID";
        }
       
    } catch (error) {
        console.error('Error:' + error);
        return null;
    }
}

